import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-35252ec0"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "ba-pot ba-column-title ba-text ba-text-center ba-column-relative"
};
const _hoisted_2 = ["id"];
const _hoisted_3 = {
  class: "potential-text ba-text"
};
const _hoisted_4 = {
  class: "potential-popup"
};
const _hoisted_5 = {
  class: "potential-popup-top"
};
const _hoisted_6 = {
  class: "potential-popup-title"
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "ba-text ba-purple"
}, " Percent of max spend potential ", -1));
const _hoisted_8 = {
  class: "potential-content"
};
const _hoisted_9 = {
  class: "potential-body"
};
const _hoisted_10 = {
  class: "potential-text ba-text ba-text-blue"
};
const _hoisted_11 = {
  class: "potential-bar"
};
const _hoisted_12 = {
  key: 0,
  class: "potential-stripes"
};
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "left-border"
}, null, -1));
const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "stripes"
}, null, -1));
const _hoisted_15 = [_hoisted_13, _hoisted_14];
const _hoisted_16 = {
  class: "potential-text ba-text"
};
const _hoisted_17 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "potential-popup-bottom ba-text ba-text-small"
}, " Max spend potential = last week’s max daily spend, adjusted for time out of budget, plus 30%. ", -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_ppc_budget_allocation_circle = _resolveComponent("ppc-budget-allocation-circle");
  const _component_percentage_value = _resolveComponent("percentage-value");
  const _component_app_icon = _resolveComponent("app-icon");
  const _component_currency_value = _resolveComponent("currency-value");
  const _component_app_popover = _resolveComponent("app-popover");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
    class: "potential",
    id: $props.item_id
  }, [_createVNode(_component_ppc_budget_allocation_circle, {
    percent: $props.value * 100
  }, null, 8, ["percent"]), _createElementVNode("div", _hoisted_3, [_createVNode(_component_percentage_value, {
    value: $props.value,
    type: "ba_table"
  }, null, 8, ["value"])])], 8, _hoisted_2), _createVNode(_component_app_popover, {
    target: $props.item_id,
    popup: "",
    "gray-arrow": "",
    "auto-width": "",
    placement: "top"
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createVNode(_component_app_icon, {
      icon: "ai",
      size: 14,
      color: "#5A52AE"
    }), _hoisted_7]), _createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_createVNode(_component_currency_value, {
      value: $props.current_budget,
      currency: $props.currency,
      precision: $props.currency_precision,
      allowPrecisionModification: false
    }, null, 8, ["value", "currency", "precision"])]), _createElementVNode("div", _hoisted_11, [_createElementVNode("div", {
      class: _normalizeClass(["potential-inner", $options.getPotentialColor($props.value)]),
      style: _normalizeStyle({
        width: `${$options.getPotentialWidth($props.value)}%`
      })
    }, [_createElementVNode("div", {
      class: "potential-cursor",
      style: _normalizeStyle({
        right: $props.value > 0 ? '1px' : '-1px'
      })
    }, null, 4), _createElementVNode("div", {
      class: _normalizeClass(["potential-percent ba-text", $options.getPotentialColor($props.value)])
    }, [_createVNode(_component_percentage_value, {
      value: $props.value,
      type: "ba_table"
    }, null, 8, ["value"])], 2), $props.value * 100 > 100 ? (_openBlock(), _createElementBlock("div", _hoisted_12, _hoisted_15)) : _createCommentVNode("", true)], 6)]), _createElementVNode("div", _hoisted_16, [_createVNode(_component_currency_value, {
      value: $props.potential_budget,
      currency: $props.currency,
      precision: $props.currency_precision,
      allowPrecisionModification: false
    }, null, 8, ["value", "currency", "precision"])])])])]), _hoisted_17])]),
    _: 1
  }, 8, ["target"])]);
}